import { render, staticRenderFns } from "./dataReport.vue?vue&type=template&id=4bb44897&scoped=true&"
import script from "./dataReport.vue?vue&type=script&lang=js&"
export * from "./dataReport.vue?vue&type=script&lang=js&"
import style0 from "./dataReport.vue?vue&type=style&index=0&id=4bb44897&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb44897",
  null
  
)

export default component.exports